import './CommonButton.less';

import clsx from 'clsx';
import React, { FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import LoadingIcon from '../../../icons/LoadingIcon';

export interface CommonButtonProps {
    children?: ReactNode;
    className?: string;
    disabled?: boolean;
    icon?: FunctionComponent;
    label?: ReactNode;
    loading?: boolean;
    onClick: MouseEventHandler;
    variant?: 'primary' | 'secondary' | string;
    size?: 'small' | 'medium' | 'large' | 'extra-large' | string;
    color?: 'blue' | 'violet' | 'green' | 'grey' | 'purple' | 'black' | string;
    dataAtid?: string;
    href?: any;
    cRef?: React.MutableRefObject<any>;
    defaultWidth?: boolean;
}

export default function CommonButton({
    children,
    className,
    disabled: dis,
    icon: Icon,
    label,
    loading,
    onClick,
    variant,
    size,
    defaultWidth,
    dataAtid,
    href,
    color,
    cRef,
    ...rest
}: CommonButtonProps) {
    const disabled = dis || loading;
    return href ? (
        <a
            role="button"
            href={disabled ? null : href}
            className={clsx('nui-link pointer fs-16 px-10', { disabled }, className)}
            data-atid={dataAtid}
            {...rest}
        >
            {loading ? <LoadingIcon /> : Icon ? <Icon /> : null}
            {label}
        </a>
    ) : (
        <button
            ref={cRef}
            className={clsx(
                'nui-btn flex items-center pointer justify-center br-radius-xs px-10',
                {
                    'nui-btn-primary': variant === 'primary',
                    'nui-btn-secondary': variant === 'secondary',
                    'nui-btn-elg': size === 'extra-large',
                    'nui-btn-lg': size === 'large',
                    'nui-btn-md': size === 'medium',
                    'nui-btn-sm': size === 'small',
                    'nui-btn-180': defaultWidth,
                    'nui-btn-blue': color === 'blue',
                    'nui-btn-green': color === 'green',
                    'nui-btn-purple': color === 'purple',
                    'nui-btn-violet': color === 'violet',
                    'nui-btn-grey': color === 'grey',
                    'nui-btn-black': color === 'black',
                    'nui-btn-white': color === 'white',
                    'nui-btn-loading': loading,
                    disabled
                },
                className
            )}
            disabled={disabled}
            type="button"
            onClick={disabled ? null : onClick}
            data-atid={dataAtid}
            {...rest}
        >
            {loading ? <LoadingIcon /> : Icon ? <Icon /> : null}
            <span>{label}</span>
            {children}
        </button>
    );
}
